import { RouteRecordRaw } from "vue-router";

export const cloudFaultRoutes: RouteRecordRaw[] = [
  {
    path: "/cloud-faults",
    name: "CloudFaultList",
    component: () => import("../views/CloudFaultList.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "cloudFault",
      requiredRight: "viewUI",
    },
  },
];
